export const strokeStyle = '#00000050';

export const DEFAULT_PATH_LENGTH = 1000;
export const DEFAULT_NUMBER_OF_PINS = 200;
export const DEFAULT_MASK_SIZE = 90;

export const TARGET_FRAME_TIME_MS = 100;
export const MAX_BATCH_SIZE = 1000;
